module.exports = __webpack_public_path__ + "static/media/sc.69a5a13e.jpeg";